const initialState = {
    portfolio_list: [],
    portfolio_changed: true,
    portfolio_prices: [],
    portfolio_returns: [],
    portfolio_risks: [],
    portfolio_variance: null,
    portfolio_return: null
}

const portfolioReducer = (state = initialState, action) => {
    switch (action.type) {

        case "SET_PORTFOLIO_LIST":
            return {
                ...state,
                portfolio_list: action.payload,
            }
        
        case "ADD_TO_PORTFOLIO":
            const addedPortfolio = [...state.portfolio_list, action.payload]
            console.log(addedPortfolio);
            return {
                ...state,
                portfolio_list: addedPortfolio,
            }
        case "REMOVE_FROM_PORTFOLIO":
            const deletedPortfolio = state.portfolio_list.filter((stock) => stock._id !== action.payload)
            return {
                ...state,
                portfolio_list: deletedPortfolio,
            }
        case "SET_PORTFOLIO_PRICES":
            return {
                ...state,
                portfolio_prices: action.payload
            }
        
        case "SET_PORTFOLIO_RETURNS":
            return {
                ...state,
                portfolio_returns: action.payload
            }
        
        case "SET_PORTFOLIO_RISKS":
            return {
                ...state,
                portfolio_risks: action.payload
            }
        
        case "SET_PORTFOLIO_CHANGED":
            return {
                ...state,
                portfolio_changed: action.payload
            }
        
        case "SET_PORTFOLIO_VARIANCE":
            return {
                ...state,
                portfolio_variance: action.payload
            }

        case "SET_PORTFOLIO_RETURN":
            return {
                ...state,
                portfolio_return: action.payload
            }

        default:
            return state;
    }
};

export default portfolioReducer;
